import enLocale from 'element-ui/lib/locale/lang/en'

// 语言模块自动注册
const requireModule = require.context('./en', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\.js|public\/)/g, '')
  modules[moduleName] = {
    namespaced: true,
    ...requireModule(fileName).default
  }
})

let en = {...enLocale, ...modules}
export default en



// WEBPACK FOOTER //
// ./src/lang/en.js